export default {"src":"/_next/static/media/homepage-google-stars-desktop.a63ca836.svg","height":38,"width":104,"blurWidth":0,"blurHeight":0};